import { MetaDataHelper } from "../util/metaDataHelper";
import { TextBox, TextBoxProps } from "./textBox"
import { ComponentHelper } from "../util/componentHelper";
import { CheckBox } from "../components/checkBox";
import { Helper } from "../util/helper";
import { Button } from "./button";
import { Commands } from "../util/commandManager";
import { BaseField } from "./baseComponentProps";
import { MetadataRegion } from "./region";
import { Metadata } from "./commonApp";
import { MetadataTab } from "./tabStrip";
import { CommandManagerAPI } from "../../commonInterfaces";
import React from "react";

export default class FormGeneratorSearchField extends React.Component<FormGeneratorSearchFieldProps, FormGeneratorSearchFieldState> {
    private _factory = ComponentHelper.createFactory();
    private _timeoutHandle: number = null;
    private _translations = null;
    private _emptyRegions: MetadataRegion[] = [];
    private _emptyFields: BaseField[] = [];
    constructor(props) {
        super(props);
        this.state = {
            searchParameters: {
                text: "",
                levels: {
                    field: true,
                    region: true,
                    tab: true
                }
            }
        };
        this._loadTranslations();
    }

    private _load = () => {
        this.props.commandManager.runCommand("switchActiveTab", Commands.DYNAMIC, {});
    }

    private _seek = () => {
        for (let i = 0; i < this.props.metadata.tabs.length; i++) {
            this._seekTabs(this.props.metadata.tabs[i]);
        }
        this._load();
    }

    private _seekTabs = (tab: MetadataTab) => {
        const isTabVisible = this.state.searchParameters.levels.tab && this._isMatch(tab.title);
        if (Helper.hasValue(tab.regions)) {
            for (let i = 0; i < tab.regions.length; i++) {
                this._seekRegions(tab.regions[i], tab.title, isTabVisible);
            }
        } else {
            this._setTabVisibility(tab, isTabVisible);
        }
    }

    private _seekRegions = (region: MetadataRegion, tabTitle: string, isTabVisible: boolean) => {
        let isRegionVisible = this.state.searchParameters.levels.region && this._isMatch(region.title);
        if (Helper.hasValue(region.fields)) {
            let field: BaseField = null;
            let isFieldVisible: boolean = false;
            for (let i = 0; i < region.fields.length; i++) {
                field = region.fields[i];
                field.name = Helper.isNullOrEmpty(field.name) ? region.title : field.name;
                isFieldVisible = (isTabVisible || isRegionVisible || (this.state.searchParameters.levels.field && this._isMatch(field.name)));
                this._setFieldsVisibilty(field, isFieldVisible);
            }
            isRegionVisible = isRegionVisible || (region.fields.filter(field => this._isMatch(field.name)).length > 0)
        } 
        this._setRegionVibility(region, tabTitle, (isRegionVisible || isTabVisible));
    }

    private _reset = () => {
        for (let tab of this.props.metadata.tabs) {
            this._setTabVisibility(tab, true);
            for (let region of Helper.getValueOrDefault(tab.regions, this._emptyRegions)) {
                this._setRegionVibility(region, tab.title, true);
                for (let field of Helper.getValueOrDefault(region.fields, this._emptyFields)) {
                    this._setFieldsVisibilty(field, true);
                }
            }
        }
        this._load();
    }

    private _setFieldsVisibilty = (field: BaseField, value: boolean) => {
        let name: string = Helper.getValueOrDefault(field.name, "");
        MetaDataHelper.setFieldVisibility(this.props.metadata, name, value);
    }

    private _setRegionVibility = (region: MetadataRegion, tabTitle: string, value: boolean) => {
        if (Helper.hasValue(region)) {
            let regionTitle: string = Helper.getValueOrDefault(region.title, "");
            MetaDataHelper.setRegionVisibility(this.props.metadata, regionTitle, tabTitle, value);
        }
    }

    private _setTabVisibility = (tab: MetadataTab, value: boolean) => {
        let title: string = Helper.getValueOrDefault(tab.title, "");
        MetaDataHelper.setTabVisibility(this.props.metadata, title, value);
    }

    private _isMatch = (value: string) => {
        if (Helper.isNullOrEmpty(value)) {
            return false;
        } else {
            value = value.toLowerCase();
            const searchValue = this.state.searchParameters.text.toLowerCase();
            return value.indexOf(searchValue) > -1;
        }
    }

    private _createSearchTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        props.value = this.state.searchParameters.text;
        props.field.triggerOnChange = true;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this._handleTextBoxChange(value);
        }
        return (
            <>
                <TextBox {...props} />
            </>
        );
    }

    private _handleTextBoxChange = (value: string) => {
        let searchParameters = this.state.searchParameters;
        searchParameters.text = value;
        this.setState({ searchParameters }, this._afterSearchParameterChange);  
    }

    private _createCleanButton = () => {
        const buttonStyle: React.CSSProperties = {
            marginLeft: "5px"
        };
        return (
            <Button
                buttonStyle={buttonStyle}
                iconName="times"
                handleClick={this._handleButtonClick}
            />);

    }

    private _handleButtonClick = () => {
        if (!Helper.isNullOrEmpty(this.state.searchParameters.text)) {
            let searchParameter = this.state.searchParameters;
            searchParameter.text = "";
            this.setState({ searchParameters: searchParameter }, this._afterSearchParameterChange);
        }
    }

    private _createMultipleCheckBoxes = () => {
        return (
            <div className={"guiSearchField__multipleCheckBoxes"}>
                {this._createCheckBox("tab")}
                {this._createCheckBox("region")}
                {this._createCheckBox("field")}
            </div>);
    }

    private _createCheckBox = (type: "tab" | "region" | "field") => {
        let checkBoxProps = this._factory.getDefaultCheckBoxProps();
        let text: string = "";
        let onLabelClick: () => void = null;
        const parameterChanged: () => void = !Helper.isNullOrEmpty(this.state.searchParameters.text) ? this._afterSearchParameterChange : null;

        switch (type) {
            case "field":
                checkBoxProps.value = this.state.searchParameters.levels.field;
                checkBoxProps.field.name = this._translations["WebSMS.Components.FormGeneratorSearch.Field"];
                text = this._translations["WebSMS.Components.FormGeneratorSearch.Field"];
                checkBoxProps.onChange = (field: any, value: any) => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.field = value;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                onLabelClick = () => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.field = !searchParameters.levels.field;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                break;
            case "region":
                checkBoxProps.value = this.state.searchParameters.levels.region;
                checkBoxProps.field.name = this._translations["WebSMS.Components.FormGeneratorSearch.Region"];
                text = this._translations["WebSMS.Components.FormGeneratorSearch.Region"];
                checkBoxProps.onChange = (field: any, value: any) => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.region = value;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                onLabelClick = () => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.region = !searchParameters.levels.region;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                break;
            case "tab":
                checkBoxProps.value = this.state.searchParameters.levels.tab;
                checkBoxProps.field.name = this._translations["WebSMS.Components.FormGeneratorSearch.Tab"];
                text = this._translations["WebSMS.Components.FormGeneratorSearch.Tab"];
                checkBoxProps.onChange = (field: any, value: any) => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.tab = value;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                onLabelClick = () => {
                    let searchParameters = this.state.searchParameters;
                    searchParameters.levels.tab = !searchParameters.levels.tab;
                    this.setState({ searchParameters: searchParameters }, parameterChanged);
                }
                break;
        }

        return (
            <div className={"guiSearchField__multipleCheckBoxes__checkBoxes"}>
                <CheckBox {...checkBoxProps} />
                <span title={text} onClick={onLabelClick}>
                    {text}
                </span>
            </div>
        );
    }

    private _loadTranslations = () => {
        Helper.getTranslations(["WebSMS.Components.FormGeneratorSearch.Match",
            "WebSMS.Components.FormGeneratorSearch.NoMatch", "WebSMS.Components.FormGeneratorSearch.Tab",
            "WebSMS.Components.FormGeneratorSearch.Region", "WebSMS.Components.FormGeneratorSearch.Field"])
            .then((result) => {
                this._translations = result.Data;
                this.setState({});
            });
    }

    private _afterSearchParameterChange = () => {        
        let searchFunction: () => void = null;
        if(!Helper.isNullOrEmpty(this.state.searchParameters.text)) {
            searchFunction = this._seek;
        } else {
            searchFunction = this._reset;
        }

        if (Helper.hasValue(searchFunction)) {
            this._timeoutHandle = window.setTimeout(searchFunction, 1000);
        }
    }

    componentWillUnmount() {
        if (Helper.hasValue(this._timeoutHandle)) {
            clearTimeout(this._timeoutHandle);
        }
        this._reset();
    }

    componentDidUpdate() {
        if (Helper.hasValue(this._timeoutHandle))
            clearTimeout(this._timeoutHandle);
    }

    render() {        
        if (Helper.hasValue(this._translations)) {
            const style: React.CSSProperties = {
                display: "flex",
                margin: "5px"
            }
            const searchTextBox = this._createSearchTextBox();
            const button = this._createCleanButton();
            const checkBoxes = this._createMultipleCheckBoxes();
            return (
                <>
                    {checkBoxes}
                    <div style={style}>
                        {searchTextBox}
                        {button}
                    </div>
                </>);
        } else {
            return (<></>);
        }
    }
};

interface FormGeneratorSearchFieldProps {
    metadata: Metadata;
    commandManager?: CommandManagerAPI;
}

interface FormGeneratorSearchFieldState {
    searchParameters: SearchParameters;
}

interface SearchParameters {
    text: string;
    levels: {
        tab: boolean;
        region: boolean;
        field: boolean;
    }
}

